export const GET_COURSE_REQUEST = 'CoursePage/GET_COURSE_REQUEST';
export const GET_COURSE_SUCCESS = 'CoursePage/GET_COURSE_SUCCESS';
export const GET_COURSE_FAILURE = 'CoursePage/GET_COURSE_FAILURE';
export const UPDATE_FLOW_REQUEST = 'CoursePage/UPDATE_FLOW_REQUEST';
export const UPDATE_FLOW_SUCCESS = 'CoursePage/UPDATE_FLOW_SUCCESS';
export const UPDATE_FLOW_FAILURE = 'CoursePage/UPDATE_FLOW_FAILURE';
export const RESET_INPUT_EXERCISE_PROGRESS = 'CoursePage/RESET_INPUT_EXERCISE_PROGRESS';
